import { getCurrentUser } from 'aws-amplify/auth';

export function persistLocalSession({ userId, email }) {
  localStorage.setItem('user_id', userId);
  localStorage.setItem('email', email);
  localStorage.removeItem('session_expired');
}

export async function getMatchingLocalSession() {
  const localId = localStorage.getItem('user_id');
  if (!localId) return null;
  const { userId } = await getCurrentUser();
  return userId === localId ? userId : null;
}
